import api from './client';
import { unwrapData } from './response';

export const listLoyaltyCustomers = async ({ limit = 100, page = 1 } = {}) => {
  const res = await api.get('/loyalty/customers', { params: { limit, page } });
  return unwrapData(res);
};

export const getCustomerMovements = async (customerId, { limit = 100, page = 1 } = {}) => {
  const res = await api.get(`/loyalty/customers/${customerId}/movements`, {
    params: { limit, page }
  });
  return unwrapData(res);
};

export const adjustCustomerPoints = async (customerId, payload) => {
  const res = await api.post(`/loyalty/customers/${customerId}/adjustments`, payload);
  return unwrapData(res, null);
};

export const listAllRewards = async (params = {}) => {
  const res = await api.get('/loyalty/rewards/all', { params });
  return unwrapData(res);
};

export const redeemRewardAdmin = async (payload) => {
  const res = await api.post('/loyalty/redemptions', payload);
  return unwrapData(res, null);
};

export const getLoyaltySettings = async () => {
  const res = await api.get('/loyalty/settings');
  return unwrapData(res, null);
};

export const updateLoyaltySettings = async (payload) => {
  const res = await api.patch('/loyalty/settings', payload);
  return unwrapData(res, null);
};

export const getCustomerLoyalty = async (customerId) => {
  const res = await api.get(`/loyalty/customers/${customerId}`);
  return unwrapData(res, null);
};